import listReducer from './list';
import addReducer from './add';
import detailReducer from './detail';

export default {
    listReducer,
    addReducer,
    detailReducer,
};
